var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M0 0 C10.56 0 21.12 0 32 0 C32 0.66 32 1.32 32 2 C21.44 2 10.88 2 0 2 C0 1.34 0 0.68 0 0 Z ","transform":"translate(9,24)"}})}
var staticRenderFns = []

export { render, staticRenderFns }